// https://raw.githubusercontent.com/alisd23/mobx-react-router/master/LICENSE
// MIT License

// Copyright (c) 2018 Ali Sheehan-Dare

// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:

// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.

// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.

import { observable, action, observe, makeObservable } from 'mobx';

class RouterStore {
    location = null;
    history = null;

    constructor () {
        makeObservable(this, {
            location: observable,
            _updateLocation: action,
            push: action.bound,
            replace: action.bound,
            go: action.bound,
            goBack: action.bound,
            goForward: action.bound
        });
    }

    _updateLocation (newState) {
        this.location = newState;
    }

    /*
     * History methods
     */
    push = (location, state) => {
        this.history.push(location, state);
    };

    replace = (location, state) => {
        this.history.replace(location, state);
    };

    go = (n) => {
        this.history.go(n);
    };

    goBack = () => {
        this.history.goBack();
    };

    goForward = () => {
        this.history.goForward();
    };
};

const syncHistoryWithStore = (history, store) => {
    // Initialise store
    store.history = history;

    // Handle update from history object
    const handleLocationChange = (location) => {
        store._updateLocation(location.location || location);
    };

    const unsubscribeFromHistory = history.listen(handleLocationChange);
    handleLocationChange(history.location);

    const subscribe = (listener) => {
        const onStoreChange = () => {
            const rawLocation = { ...store.location };
            listener(rawLocation, history.action);
        };

        // Listen for changes to location state in store
        const unsubscribeFromStore = observe(store, 'location', onStoreChange);

        listener(store.location, history.action);

        return unsubscribeFromStore;
    };

    history.subscribe = subscribe;
    history.unsubscribe = unsubscribeFromHistory;

    return history;
};

export { RouterStore, syncHistoryWithStore };
